
import { RutaLocal } from '../componentes/funcionesEspeciales'
import Logo from '../media/img/logo_principal.png'
function Contacto() {

    return (<>
        <div className='container'>

            Hola este es un texto a editar sobre los términos y condiciones!!
        </div>
    </>)
}
export default Contacto;